import { formatOrderDate, formatOrderTime } from "../orders/format";
import { resolveCategory, resolveTone } from "./notificationCategories";
import { toDate } from "./notificationTime";

export const toId = (value) => {
  if (value === null || value === undefined || value === "") return null;

  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
};

export const statusKeyOf = (dto) => {
  const data = dto?.data || {};

  return String(
    data.status || data.orderStatus || data.eventType || dto?.topic || ""
  ).toUpperCase();
};

const mapTarget = (dto) => {
  const data = dto?.data || {};

  return {
    orderId: toId(data.orderId) ?? toId(data.subOrderId),
    masterOrderId: toId(data.masterOrderId),
    orderNumber: data.orderNumber ? String(data.orderNumber) : null,
  };
};

export const toNotification = (dto) => {
  if (!dto || dto.id === null || dto.id === undefined) return null;

  const statusKey = statusKeyOf(dto);
  const title = String(dto.title || "").trim() || "Notification";
  const body = String(dto.body || "").trim() || null;
  const createdAt = toDate(dto.createdAt);

  return {
    id: dto.id,
    title,
    body,
    read: dto.read === true,
    tone: resolveTone(statusKey),
    categoryKey: resolveCategory(statusKey, title).key,
    target: mapTarget(dto),
    createdAt: createdAt ? createdAt.toISOString() : null,
    dateLabel: createdAt ? formatOrderDate(createdAt) : "",
    timeLabel: createdAt ? formatOrderTime(createdAt) : "",
  };
};

export const mapUnreadCount = (dto) => {
  const parsed = Number(dto?.count);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};
